import React from "react";
import { Grid } from "@mui/material";
import { BarekamIcon, IconVariants } from "../../../components/icon/barekam-icon";
import BarekamText from "../../../components/text";
import { ShippingInfoModel } from "../../../shared/models/order/shipping-info.model";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import {
    ShippingMethodContainer,
    ShippingMethodContainerSelected,
    ShippingMethodSelectorContainer,
    ShippingMethodTextContainer
} from "./styled";
import { ShippingMethodModel } from "../../../shared/models/order/ShippingMethod.model";
import { onShippingMethodChange } from "../../../../services/orders.service";
import { OrderPopupCardTitle } from "../styled";
import BarekamChip from "../../../components/chip/barekamChip";
import BarekamButton, { SimpleButtons } from "../../../components/button";
import { ClickableColumnContainer } from "../../my/order-list/styled";

export const ShippingMethodSelector = (props: ShippingMethodSelectorProps) => {
    const { shippingInfo, withLink, selectedIndex } = props;

    const { shippingMethods } = useAppSelector(state => state.staticDataReducer);
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const selectedShippingMethodId = shippingInfo?.shippingMethod.shippingMethodId || 1;

    const dispatch = useAppDispatch();

    const ShippingMethods = () => {
        return (
            <Grid container columnSpacing={'1rem'} rowSpacing={'1rem'}>
                {shippingMethods.map((method, index) =>
                    <Grid item xs={matchesPhone ? 12 : 6}
                        key={method.shippingMethodId} display={'flex'} flexDirection={'column'} className="shipping-items">
                        <SingleShippingMethod selected={selectedShippingMethodId ? selectedShippingMethodId === method.shippingMethodId : index === (selectedIndex || 0)}
                            shippingMethod={method}
                            available={method.shippingMethodId === 1}
                            withLink={withLink}
                            onChange={shippingMethod => method.shippingMethodId === 1 && onShippingMethodChange(shippingMethod, dispatch)} />
                    </Grid>
                )}
            </Grid>
        )
    }

    return (
        <ShippingMethodSelectorContainer>
            <OrderPopupCardTitle>
                <BarekamText variant={'m'}>
                    <Message messageKey={'new_order_shipping_method'} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </OrderPopupCardTitle>

            <ShippingMethods />
        </ShippingMethodSelectorContainer>
    );
}

export const SingleShippingMethod = ({ shippingMethod, onChange, withLink, selected, available }: SingleShippingMethodProps) => {
    function handleButtonClick() {
        window.open('https://barekam.am/#prohibited', '_blank', 'rel=noopener noreferrer');
    }

    const ShippingInfoContent = () => (
        <><BarekamIcon variant={IconVariants.shipping}
            shippingMethod={shippingMethod.name.toLowerCase()} />
            <ShippingMethodTextContainer>
                <div style={{ display: 'flex', gap: '0.25rem', height: '1.2rem' }}>
                    <BarekamText opaque={!available} variant={'m'}>
                        <Message messageKey={shippingMethod.name} sectionId={MessageSections.ORDERS} />
                    </BarekamText>

                    {available
                        ? ''
                        : <BarekamChip messageKey={'coming_soon'} statusId={4} chipSize={'s'} />}
                </div>

                <BarekamText variant={'s'} opaque align={'center'}>
                    <Message messageKey={shippingMethod.description} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </ShippingMethodTextContainer>
        </>
    )

    return (
        <>
            {selected
                ? <ShippingMethodContainerSelected>
                    <ShippingInfoContent />
                </ShippingMethodContainerSelected>
                : <ShippingMethodContainer onClick={() => onChange(shippingMethod)}>
                    <ShippingInfoContent />
                </ShippingMethodContainer>
            }

            {withLink
                ? <ClickableColumnContainer>
                    <BarekamButton type={SimpleButtons.LINK} onClick={() => handleButtonClick()}>
                        <BarekamText variant={'s'}>
                            <Message messageKey={'see_prohibited_items'} sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </BarekamButton>
                </ClickableColumnContainer>
                : ''
            }
        </>
    );
}

interface ShippingMethodSelectorProps {
    shippingInfo?: ShippingInfoModel;
    selectedIndex?: number;
    selectedCountryId?: number;
    withLink?: boolean;
}

interface SingleShippingMethodProps {
    shippingMethod: ShippingMethodModel,
    onChange: (shippingMethod: ShippingMethodModel) => void,
    available: boolean
    selected?: boolean,
    withLink?: boolean,
}
